import React, { useState, Fragment } from 'react';
import {
  BsCaretLeftFill,
  BsCaretRightFill,
} from 'react-icons/bs';

function DatagridHeaderCW({ t, isPc, setIsPc }) {
  return (
    <Fragment>
      <tr>
        <th rowSpan="2">
          {t('txt-symbol')}
        </th>
        <th rowSpan="2">
          TCPH
        </th>
        <th rowSpan="2">
          GDCC
        </th>
        <th rowSpan="2" className="high-light">
          {t('txt-ref')}
        </th>
        <th rowSpan="2" className="high-light">
          {t('txt-ceil')}
        </th>
        <th rowSpan="2" className="high-light">
          {t('txt-floor')}
        </th>
        <th colSpan="6">{t('txt-bid')}</th>
        <th colSpan="3" className="high-light">
          {t('txt-match')}
        </th>
        <th colSpan="6">{t('txt-ask')}</th>
        <th rowSpan="2" className="high-light">
          {t('txt-high')}
        </th>
        <th rowSpan="2" className="high-light">
          {t('txt-low')}
        </th>
        <th rowSpan="2">
          {t('txt-total-vol')}
        </th>
        <th colSpan="2">CK cơ sở</th>
        <th rowSpan="2">
          TH
        </th>
        <th rowSpan="2">
          Tỉ lệ chuyển đổi
        </th>
      </tr>
      <tr>
        <th>{t('txt-price')} 3</th>
        <th>{t('txt-vol')} 3</th>
        <th>{t('txt-price')} 2</th>
        <th>{t('txt-vol')} 2</th>
        <th>{t('txt-price')} 1</th>
        <th>{t('txt-vol')} 1</th>
        <th className="high-light">
          {t('txt-price')}
        </th>
        <th className="high-light">{t('txt-vol')}</th>
        <th className="high-light position-relative">
          <BsCaretLeftFill
            className="tbl-toggle-left"
            onClick={() => setIsPc(!isPc)}
          />
          {isPc ? '%' : '+/-'}
          <BsCaretRightFill
            className="tbl-toggle-right"
            onClick={() => setIsPc(!isPc)}
          />
        </th>
        <th>{t('txt-price')} 1</th>
        <th>{t('txt-vol')} 1</th>
        <th>{t('txt-price')} 2</th>
        <th>{t('txt-vol')} 2</th>
        <th>{t('txt-price')} 3</th>
        <th>{t('txt-vol')} 3</th>
        <th>CK</th>
        <th>Giá</th>
      </tr>
    </Fragment>
  );
}

export default DatagridHeaderCW;
